import GeckoStore from 'services/gecko-store';
import {
  EditorState,
  SelectionState,
  convertFromRaw,
  convertToRaw,
} from 'draft-js';

export const clearDrafts = (props) => {
  GeckoStore.localStorage.remove(`messageDraft-${props.conversationId}`);
};

export const saveDrafts = (props, state) => {
  clearDrafts(props);
  const draftText = state.editorState.getCurrentContent();
  const recipientChannelId = state.recipientChannel
    ? state.recipientChannel.id
    : null;
  if (draftText.hasText()) {
    return GeckoStore.localStorage.set(
      `messageDraft-${props.conversationId}`,
      JSON.stringify({
        noteMode: state.noteMode.on,
        draft: convertToRaw(draftText),
        channel: recipientChannelId,
      })
    );
  }
};

const getEditorStateEndSelection = (editorState) => {
  const content = editorState.getCurrentContent();
  const blockMap = content.getBlockMap();

  const key = blockMap.last().getKey();
  const length = blockMap.last().getLength();

  return new SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length,
  });
};

export const retrieveDrafts = (props) => {
  const draft = JSON.parse(
    GeckoStore.localStorage.get(`messageDraft-${props.conversationId}`)
  );
  const basicEditorState = draft
    ? EditorState.createWithContent(convertFromRaw(draft.draft))
    : EditorState.createEmpty();
  const endSelection = getEditorStateEndSelection(basicEditorState);
  const editorState = EditorState.forceSelection(
    basicEditorState,
    endSelection
  );
  if (!draft) {
    return { message: editorState };
  } else if (draft.noteMode) {
    return { note: editorState, channel: draft.channel };
  } else {
    return { message: editorState, channel: draft.channel };
  }
};

export const RBWdrafts = {
  clearDrafts,
  saveDrafts,
  retrieveDrafts,
};
